import Keycloak from "keycloak-js";

// Define the configuration
const keycloakConfig = {
  realm: import.meta.env.VITE_KEYCLOAK_REALM || "supervity",
  url: import.meta.env.VITE_KEYCLOAK_URL?.replace(/\/+$/, '') || "https://supervity-keycloak-67689851625.us-central1.run.app",
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "super-client-dnh-dev-0001",
  "ssl-required": "external",
  "public-client": true,
  "confidential-port": 0,
};

console.log("Initializing Keycloak with config:", {
  url: keycloakConfig.url,
  realm: keycloakConfig.realm,
  clientId: keycloakConfig.clientId
});

const keycloak = new Keycloak(keycloakConfig);

// ───────────────────────────────────────────────────────────────
// Monkey-patch: route /token requests through our backend proxy
// so the server can inject the confidential client_secret.
//
// Confirmed: super-client-dnh-dev-0001 is a CONFIDENTIAL client
// (publicClient=False in Keycloak admin API). keycloak-js v22
// does not support client_secret natively, so the backend endpoint
//   POST /api/auth/keycloak/token
// forwards the form body to Keycloak with client_secret appended.
// ───────────────────────────────────────────────────────────────
const _origXHROpen = XMLHttpRequest.prototype.open;
const _origXHRSend = XMLHttpRequest.prototype.send;

// Track the URL per instance so we can check it in .send()
XMLHttpRequest.prototype.open = function (method, url, ...rest) {
  this._kcUrl = url;
  return _origXHROpen.call(this, method, url, ...rest);
};

XMLHttpRequest.prototype.send = function (body) {
  if (
    typeof this._kcUrl === "string" &&
    this._kcUrl.includes("/protocol/openid-connect/token")
  ) {
    // Always use a same-origin relative path:
    //   production : nginx ^~ /api/auth/keycloak → nesic-accresearch-api:8000
    //   dev        : Vite proxy /api/auth/keycloak → http://backend:8000
    const proxyUrl = "/api/auth/keycloak/token";
    console.log("🔑 Redirecting Keycloak token request through backend proxy:", proxyUrl);
    _origXHROpen.call(this, "POST", proxyUrl, true);
    this.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  }
  return _origXHRSend.call(this, body);
};

export default keycloak;